import { createGlobalStyle } from 'styled-components'
import { xs, md } from 'utils/breakpoints'
import { mainFont } from 'utils/styled'

const GlobalStyle = createGlobalStyle`
  html {
    scrollbar-gutter: stable;
  }
  :root {
    --color-primary: ${({ theme }) => theme.colors.primary};
    --color-secondary: ${({ theme }) => theme.colors.secondary};
    --color-white: ${({ theme }) => theme.colors.white};
    --color-font-secondary: ${({ theme }) => theme.colors.fontSecondary};
    --color-font-muted: ${({ theme }) => theme.colors.fontMuted};
    --color-border-secondary: ${({ theme }) => theme.colors.borderSecondary};
    --color-background-hover: ${({ theme }) => theme.colors.backgroundHover};
  }

  body {
    ${mainFont}
    ${xs`font-size: 14px;`}
    ${md`
font-size: 15px;
    `}
    margin: 0;
    overflow-y: scroll;
  }
`

export default GlobalStyle
